"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = _interopRequireDefault(require("@/mixins/product"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  mixins: [_product.default],
  //此js存放团购券的部分函数方法
  data: function data() {
    return {
      formValidate: {
        type: 2
      },
      productType: [
      // { tit: '普通团购券', id: 0, tips: '实体货物' },
      // { tit: '云盘团购券', id: 5, tips: '同一链接发货' },
      // { tit: '卡密团购券', id: 6, tips: '不同充值码发货' },
      {
        tit: '虚拟团购券',
        id: 2,
        tips: '虚拟发货'
      }],
      //团购券类型
      proTypedialogVisible: false //选择团购券类型弹窗
    };
  },
  props: {
    addType: {
      type: String,
      default: function _default() {
        return 'isAdd';
      }
    }
  },
  methods: {
    //选择团购券类型确定
    handleSureType: function handleSureType() {
      this.proTypedialogVisible = false;
      var addType = this.addType === 'isAdd' ? 2 : 1;
      //id:团购券id，isDisabled：是否能编辑(1不能，2能)，isCopy：是否是采集团购券(1是，2不是)
      this.$router.push({
        path: "/canteen-product/list/creatProduct/0/2/".concat(addType, "/").concat(this.formValidate.type)
      });
    },
    //选择团购券类型
    handleChangeProductType: function handleChangeProductType(id) {
      this.formValidate.type = id;
    }
  }
};